import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useDatosAlta } from "../lib/planes";

export default function Demo() {
  const { demoLogin } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState(null);
  const attempted = useRef(false);
  const contacto = useDatosAlta().datos?.contacto_email; // TEN.4: UNA constante del backend

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    (async () => {
      try {
        await demoLogin();
        nav("/app", { replace: true });
      } catch (e) {
        setError(
          e?.response?.status === 429
            ? "Demasiadas personas probando la demo en este momento. Intenta de nuevo en un minuto."
            : "No pudimos preparar tu demo en este momento."
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8 bg-slate-50">
        <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl shadow-card p-8 text-center">
          <h1 className="font-display text-xl font-bold text-slate-900 mb-2">No pudimos abrir la demo</h1>
          <p className="text-slate-600 text-sm mb-6">{error}</p>
          {contacto && (
          <a
            href={`mailto:${contacto}`}
            className="inline-flex items-center justify-center gap-2 bg-brand-electric text-white font-medium px-4 py-2.5 rounded-xl hover:bg-blue-700 transition-colors"
          >
            Contactar a {contacto}
          </a>
          )}
          <div className="mt-6 text-xs text-slate-400 flex items-center justify-center gap-4">
            <a href="https://surit.ai/seguridad" target="_blank" rel="noopener noreferrer" className="hover:text-slate-600">Seguridad</a>
            <a href="https://surit.ai/privacidad" target="_blank" rel="noopener noreferrer" className="hover:text-slate-600">Privacidad</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-500">
      Preparando tu demo…
    </div>
  );
}
